
/**
 * Message for application log.
 */
export interface LogMessage {
    /** Logger name to use. */
    loggerName: string;

    /** Log message. */
    message: string;

    /** Log level. Will use "INFO" if omitted. */
    level?: "ERROR" | "WARN" | "INFO" | "DEBUG" | "TRACE"

    /** Optional map of properties to attach to log message. Note that user name and other basic properties
       will be set by the logging framework itself. */
    context?: Map<string, string>
}

/**
 * Log a message to application log. Will be sent to server (requires logged in user).
 *
 * @param message Log message and metadata
 */
export function sendLog(message: LogMessage): void {

    fetch("/rest/log", {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(message)
    }).then(response => {
        if (!response.ok) {
            console.log("Logging to server failed", response);
        }
    }).catch(reason => {
        console.log("Network error when logging to server", reason);
    })
}